import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from "react";
import { motion, useTransform, useViewportScroll, useSpring } from 'framer-motion';
import { directions } from "./animationConstants";
import $ from 'jquery';

export default function Parallax({
  children,
  direction = directions.BTT,
  classes = "",
  triggers = [1.2, 0.5],
  offset = 0,
  id,
  length = 200,
  opacity = false, }) {
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const { scrollY } = useViewportScroll();
  const easing = [0.42, 0, 0.58, 1];
  const { LTR, RTL, BTT, TTB } = directions;
  let initial = { y: 0 - length };
  if (direction === TTB) initial = { y: length };
  else if (direction === RTL) initial = { x: length };
  else if (direction === LTR) initial = { x: 0 - length };
  if (opacity) initial.opacity = 0;
  const setValues = () => {
    setIsMobile(window.innerWidth <= 767);
    setTimeout(() => {
      (!isMobile && $("#" + id).length) && setElementTop($("#" + id).offset().top);
      !isMobile && setClientHeight(window.innerHeight);
    }, 500);
  };

  useEffect(() => {
    (window.innerWidth >= 767) && setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });

  const getScrollValue = (trigger) => {
    return elementTop - clientHeight * trigger;
  };

  const springVar = { type: "spring", damping: 50, stiffness: 500 };
  const range = offset ? [getScrollValue(triggers[0]), getScrollValue(triggers[1]) + offset] : [getScrollValue(triggers[0]), getScrollValue(triggers[1])];
  const btt_rtl = useTransform(scrollY, range, [length, 0], easing);
  const btt_rtl_op = useTransform(scrollY, range, [0, 1], easing);
  const ttb_ltr = useTransform(scrollY, range, [0 - length, 0], easing);
  const ttb_ltr_op = useTransform(scrollY, range, [0, 1], easing);

  const getStyle = (dir, opacity) => {
    switch (dir) {
      case BTT:
        if (opacity) return { y: btt_rtl, opacity: btt_rtl_op };
        return { y: btt_rtl };
      case RTL:
        if (opacity) return { x: btt_rtl, opacity: btt_rtl_op };
        return { x: btt_rtl };
      case LTR:
        if (opacity) return { x: ttb_ltr, opacity: ttb_ltr_op };
        return { x: ttb_ltr };
      case TTB:
        if (opacity) return { y: ttb_ltr, opacity: ttb_ltr_op };
        return { y: btt_rtl };
      default:
        return { y: btt_rtl };
    }
  };

  return (
    <>
      {classes ?
        (!isMobile ? <motion.div
          className={classes}
          style={getStyle(direction, opacity)}
          transition={springVar}
          onLoad={setValues}
          id={id}>
          {children}
        </motion.div> :
          <div className={classes} id={id}>
            {children}
          </div>)
        :
        (!isMobile ?
          <>
            {React.cloneElement(children, { style: getStyle(direction, opacity), id: id, transition: springVar })}
          </> :
          <>
            {children}
          </>
        )
      }
    </>
  );
}
